export default __webpack_public_path__ + "images/bb394384-reports.svg";